import React, { createContext, useContext } from 'react';

import { noop } from 'lodash';

import {
  UseSponsorCompaniesReturnType,
  useSponsorCompaniesInternal,
} from 'hooks/useSponsorCompaniesInternal';

const initialContext: UseSponsorCompaniesReturnType = {
  isLoading: false,
  isCompaniesDataLoading: false,
  isSponsorsDataLoading: false,
  companiesData: [],
  searchText: '',
  societySponsorCompanies: [],
  inConversationCompanies: [],
  sponsorCompanyIds: [],
  sponsorRequestCompanyIds: [],
  messageCompanyIds: [],
  fetchMoreData: () => {},
  setSearchText: noop,
  setIndustryIds: noop,
  setCompanySizes: noop,
  setFilterByVerified: noop,
  generateGPTMessage: () => new Promise(noop),
  sendMessageToCompany: () => new Promise(noop),
  inviteSponsor: () => new Promise(noop),
  removeSponsor: () => new Promise(noop),
  updateSponsorPlan: () => new Promise(noop),
  onCloseNotification: () => new Promise(noop),
  mutateSponsorshipData: () => new Promise(noop),
};

const SocietySponsorshipContext =
  createContext<UseSponsorCompaniesReturnType>(initialContext);

export const useSponsorCompanies = () => useContext(SocietySponsorshipContext);

export const SocietySponsorshipProvider: React.FC = ({ children }) => {
  const value = useSponsorCompaniesInternal();

  return (
    <SocietySponsorshipContext.Provider value={value}>
      {children}
    </SocietySponsorshipContext.Provider>
  );
};
